/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ConfluencePageSubType {
  LIVE = "LIVE",
}

export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

export interface ContentSpecificCreateInput {
  key: string;
  value: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateContentMutation
// ====================================================

export interface CreateContentMutation_createContentContextual_space {
  id: string | null;
  alias: string | null;
  key: string | null;
}

export interface CreateContentMutation_createContentContextual_links {
  editui: string | null;
  context: string | null;
}

export interface CreateContentMutation_createContentContextual_metadata_frontend {
  collabService: string | null;
}

export interface CreateContentMutation_createContentContextual_metadata {
  frontend: CreateContentMutation_createContentContextual_metadata_frontend | null;
}

export interface CreateContentMutation_createContentContextual {
  id: string | null;
  space: CreateContentMutation_createContentContextual_space | null;
  links: CreateContentMutation_createContentContextual_links | null;
  metadata: CreateContentMutation_createContentContextual_metadata;
  subType: string | null;
}

export interface CreateContentMutation {
  createContentContextual: CreateContentMutation_createContentContextual;
}

export interface CreateContentMutationVariables {
  subType?: ConfluencePageSubType | null;
  spaceKey: string;
  parentId?: string | null;
  title?: string | null;
  status: GraphQLContentStatus;
  contentSpecificCreateInput?: ContentSpecificCreateInput[] | null;
  type: string;
}
